document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.reviews-grid-section:not([data-reviews-js-ready])');

  sections.forEach(function (section) {
    section.setAttribute('data-reviews-js-ready', 'true');

    var modal = section.querySelector('[data-reviews-modal]');
    if (!modal) return;

    var openBtn = section.querySelector('[data-reviews-open-modal]');
    var closeEls = modal.querySelectorAll('[data-reviews-close-modal]');
    var form = modal.querySelector('[data-reviews-form]');
    var successEl = modal.querySelector('[data-reviews-success]');
    var starPicker = modal.querySelector('[data-reviews-star-picker]');
    var ratingInput = modal.querySelector('[data-reviews-rating-input]');
    var photoInput = modal.querySelector('[data-reviews-photo-input]');
    var photoPreview = modal.querySelector('[data-reviews-photo-preview]');

    var stars = starPicker ? Array.prototype.slice.call(starPicker.querySelectorAll('.reviews-form__star')) : [];
    var selectedFiles = [];

    function paintStars(value) {
      stars.forEach(function (star) {
        var starValue = parseInt(star.getAttribute('data-value'), 10);
        star.classList.toggle('is-filled', starValue <= value);
      });
    }

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      // reset back to the form view for next time, after the closing animation-free hide
      window.setTimeout(resetForm, 200);
    }

    function resetForm() {
      if (form) {
        form.reset();
        form.hidden = false;
      }
      if (successEl) successEl.hidden = true;
      if (ratingInput) ratingInput.value = '0';
      paintStars(0);
      selectedFiles = [];
      if (photoPreview) photoPreview.innerHTML = '';
    }

    if (openBtn) {
      openBtn.addEventListener('click', openModal);
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    // Star rating picker
    stars.forEach(function (star) {
      star.addEventListener('click', function () {
        var value = parseInt(star.getAttribute('data-value'), 10);
        if (ratingInput) ratingInput.value = String(value);
        paintStars(value);
      });

      star.addEventListener('mouseenter', function () {
        var value = parseInt(star.getAttribute('data-value'), 10);
        paintStars(value);
      });
    });

    if (starPicker) {
      starPicker.addEventListener('mouseleave', function () {
        var current = ratingInput ? parseInt(ratingInput.value, 10) || 0 : 0;
        paintStars(current);
      });
    }

    // Photo upload preview
    if (photoInput) {
      photoInput.addEventListener('change', function () {
        var files = Array.prototype.slice.call(photoInput.files || []);
        selectedFiles = selectedFiles.concat(files);
        files.forEach(addPhotoThumb);
      });
    }

    function addPhotoThumb(file) {
      if (!photoPreview || !file.type || file.type.indexOf('image') !== 0) return;

      var reader = new FileReader();
      reader.onload = function (e) {
        var thumb = document.createElement('div');
        thumb.className = 'reviews-form__photo-thumb';

        var img = document.createElement('img');
        img.src = e.target.result;
        img.alt = file.name;
        thumb.appendChild(img);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'reviews-form__photo-remove';
        removeBtn.setAttribute('aria-label', 'Remove photo');
        removeBtn.textContent = '\u00d7';
        removeBtn.addEventListener('click', function () {
          thumb.remove();
          selectedFiles = selectedFiles.filter(function (f) { return f !== file; });
        });
        thumb.appendChild(removeBtn);

        photoPreview.appendChild(thumb);
      };
      reader.readAsDataURL(file);
    }

    // Fake submit: no network request, just show a success message
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        form.hidden = true;
        if (successEl) successEl.hidden = false;
      });
    }
  });
});
